import React from 'react';
import { useLayoutEffect, useRef, useState } from 'react';
import { getLabel } from '../data/labels';
import BetsOddsHeader from '../common/BetsOddsHeader';
import IconsScroller from '../common/IconsScroller';
import Loader from '../common/Loader';
import MessageInfo from '../common/MessageInfo';
import { useFetch } from '../data/fetch/useFetch';
import { parseWidgetData } from '../data/parseWidgetData';
import { classIf, filterBetsByNumberOfOdds, filtraParametriche, getConfiguration, iconSportCssClass } from '../data/utils';
import PrematchTournamentMatch from '../prematch/prematch-home/PrematchTournamentMatch';
import { adjustOddsAlignment } from '../tables-utils';
import PrematchContext from '../contexts/PrematchContext';

function UpcomingContent(props) {
    const prematchContext = React.useContext(PrematchContext);
    const [selectedSport, setSelectedSport] = useState(props.sports[0]);
    const iconsContainer = useRef(null);

    function openEvent(event) {
        const tournamentUniqueId = `${event.sportRef}_${event.categoryRef}_${event.tournamentRef}`;
        prematchContext.openEvent(tournamentUniqueId, event);
    }

    useLayoutEffect(() => {
        adjustOddsAlignment();
    });

    const sportButtons = props.sports.map((sport, index) => {
        const selected = sport === selectedSport;
        return (
            <div className={"icona-slider-sport" + classIf(selected, 'icona-selezionata')} style={{order: props.order}} onClick={() => setSelectedSport(sport)}>
                <figure className="sport-icona-live">
                    {(props.counter != null && props.counter > 0) &&
                        <span className="contatore-live-icone">{props.counter}</span>
                    }
                    <div className={`img-fluid ico-sport ${iconSportCssClass(sport, null)}`}></div>
                    <span>{props.descBySport[sport]}</span>
                </figure>
            </div>
        );
    });

    const matches = props.matchesBySport[selectedSport];

    let scommesse = matches?.[0]?.gruppiScommessa?.[0]?.scommesse;
    if (scommesse) {
        scommesse = filtraParametriche(scommesse);
        scommesse = filterBetsByNumberOfOdds(scommesse);
    }

    return (
        <div className="tab-pane fade show active" id="scheda-top-match-2" role="tabpanel">
            <div className="container-slider-icone mb-2 overflow-unset has-icons-container-no-wrap">
                <div className="icons-slider-container">
                    <div className="slider-icone-sport horiz-sc icons-container icons-container-no-wrap" ref={iconsContainer}>
                        {sportButtons}
                    </div>
                    <IconsScroller buttons={sportButtons} iconsContainer={iconsContainer.current} />
                </div>
            </div>
            <div className="bg-nero bianco titolo-blocco-sport pointer">
                <span className="d-centro-v maiuscolo">
                    <div className={`img-fluid icona-sport margine-dx-mezzo ico-sport ${iconSportCssClass(selectedSport, null)}`}></div>
                    {props.descBySport[selectedSport]}
                </span>
            </div>
            {scommesse == null ?
                <div className="tab-pane fade show active" id="scheda-top-match-2" role="tabpanel">
                    <MessageInfo message={`${getLabel('prematch_page.widget.last_minute')} ${getLabel('general.chiuso')}`} />
                </div>
                :
                <div className="blocco-quote-espanse">
                    <div className="contenitore-table bg-bianco collapse show bordo-tondo" id="tabella-c">
                        <div className="contenitore-table bg-bianco collapse show bordo-tondo">
                            <div className="tabellaQuoteIntestazione text_s1 tabellaQuoteIntestazionePrematch mb-2 tabellaQuotePrematch_5col">
                                <div className="tabellaQuoteAlias d-flex justify-content-center align-items-center">{getLabel('prematch_page.torneo.tournament_day_header.alias')}</div>
                                <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                                    <p>{getLabel('prematch_page.torneo.tournament_day_header.time')}</p>
                                </div>
                                <div className="tabellaQuoteSquadre"></div>
                                <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1">
                                    <BetsOddsHeader bets={scommesse} />
                                </div>
                                <div className="tabellaQuoteStatistiche"></div>
                                <div className="tabellaQuoteAltre"></div>
                            </div>
                            {matches.map(function(match) {
                                return (
                                    <PrematchTournamentMatch key={match.id}
                                                             match={match}
                                                             isLive={false}
                                                             isLastMinute={true}
                                                             openMatch={openEvent}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default function Upcoming() {
    const conf = getConfiguration();
    const [isLoading, isError, data] = useFetch(conf.api.getWidgetCentrali, null, (data) =>
        parseWidgetData(data, false)
    );

    if (isLoading || isError) {
        return <Loader error={isError} />;
    }

    return (
        <UpcomingContent {...data.lastMinute} />
    );
}
